<mat-tab-group (selectedTabChange)="tabChanged($event)" class="posgrados mb-5" animationDuration="2000ms">
    <mat-tab *ngFor="let item of list" [label]="item.title">
        <div class="content-panel" [id]="item.title"></div>
    </mat-tab>
    <!--<mat-tab label="Métodos de pago" *ngIf="!existMP">
        <app-metodos-de-pago-continua-posgrado [posgrados]="true"></app-metodos-de-pago-continua-posgrado>
    </mat-tab>-->
</mat-tab-group>